gz-form-field {
  --form-field-label-width: 100px;
}
.action-buttons {
  padding: calc(4 * var(--spacer)) calc(var(--spacer) / 2) calc(var(--spacer) / 2) calc(var(--spacer) / 2);
  display: flex;
  justify-content: space-between;
}
